import React from 'react';
import Icon, { type IconProps } from '@atlaskit/icon';

const UnscheduledIconSVG = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15 2C15.5128 2 15.9355 2.38602 15.9933 2.88336L16 3V4H18C19.0544 4 19.9182 4.81585 19.9945 5.85071L20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8V3C8 2.44771 8.44771 2 9 2C9.51284 2 9.93551 2.38602 9.99327 2.88336L10 3V4H14V3C14 2.44771 14.4477 2 15 2ZM18 11H6V18H18V11ZM8 6H6V9H18V6H16V7C16 7.55229 15.5523 8 15 8C14.4872 8 14.0645 7.61398 14.0067 7.11664L14 7V6H10V7C10 7.55229 9.55229 8 9 8C8.48716 8 8.06449 7.61398 8.00673 7.11664L8 7V6Z"
			fill="currentColor"
		/>
	</svg>
);

const UnscheduledIcon = (props: IconProps) => <Icon glyph={UnscheduledIconSVG} {...props} />;

export default UnscheduledIcon;
